import ProductPhoneNumberGroup from 'src/app/display-model/product-phone-number-group';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Company from 'src/app/model/company/company';
import Product from 'src/app/model/product/product';
import ProductPhoneNumber from 'src/app/model/product/product-phone-number';
import { Project } from 'src/app/model/project/project';

export class ClientProductSummaryHelper {
  private constructor() {}

  static getProductPhoneNumberGroups(
    product: Product,
    project: Project,
    projectContactToCompany: Map<number, Company>,
    client: boolean
  ): ProductPhoneNumberGroup[] {
    if (!client || (client && project.id != null)) {
      return this.getProductPhoneNumbersWithExistingProjectContacts(
        product,
        projectContactToCompany
      );
    } else {
      return this.getProductPhoneNumbersClient(product, project);
    }
  }

  private static getProductPhoneNumbersWithExistingProjectContacts(
    product: Product,
    projectContactToCompany: Map<number, Company>
  ): ProductPhoneNumberGroup[] {
    const companyToPhoneNumbers = new Map<number, ProductPhoneNumber[]>();
    if (CollectionHelper.isPopulated(product.productPhoneNumbers)) {
      product.productPhoneNumbers.forEach(n => {
        if (!this.phoneNumberIsEmpty(n) && n.projectContact != null) {
          const company = projectContactToCompany.get(n.projectContact.id);
          if (company != null) {
            let arr = companyToPhoneNumbers.get(company.id);
            if (arr == null) {
              arr = [];
              companyToPhoneNumbers.set(company.id, arr);
            }
            arr.push(n);
          }
        }
      });
    }
    const groups: ProductPhoneNumberGroup[] = [];
    companyToPhoneNumbers.forEach((arr, companyId) => {
      if (CollectionHelper.isPopulated(arr)) {
        const company = projectContactToCompany.get(arr[0].projectContact.id);
        if (company != null) {
          const group: ProductPhoneNumberGroup = {
            companyId: companyId,
            companyName: company.regularName,
            phoneNumbers: arr.map(n => n.phoneNumbers)
          };
          groups.push(group);
        }
      }
    });
    return groups;
  }

  private static getProductPhoneNumbersClient(
    product: Product,
    project: Project
  ): ProductPhoneNumberGroup[] {
    const groups: ProductPhoneNumberGroup[] = [];

    if (
      CollectionHelper.isPopulated(project.projectContacts) &&
      CollectionHelper.isPopulated(product.productPhoneNumbers)
    ) {
      const phoneNumbers = product.productPhoneNumbers
        .filter(n => !this.phoneNumberIsEmpty(n))
        .map(n => n.phoneNumbers);
      if (phoneNumbers.length > 0) {
        const group: ProductPhoneNumberGroup = {
          companyId: project.projectContacts[0].company.id,
          companyName: project.projectContacts[0].company.regularName,
          phoneNumbers: product.productPhoneNumbers.map(n => n.phoneNumbers)
        };
        groups.push(group);
      }
    }

    return groups;
  }

  private static phoneNumberIsEmpty(
    productPhoneNumber: ProductPhoneNumber
  ): boolean {
    return (
      productPhoneNumber.phoneNumbers == null ||
      productPhoneNumber.phoneNumbers === '' ||
      productPhoneNumber.phoneNumbers === 'Geen'
    );
  }
}
